<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="m-t-lg">
          <h1>Counterpart 360</h1>
          <p>Search for information about a specific counterpart.</p>
          <br />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header bg-transparent">
            Search
            <hr>
          </div>
          <div class="card-body">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                id="query"
                v-model="query"
                placeholder="Name of entity"
              />
              <span class="input-group-btn">
                <button
                  @click="() => search()"
                  class="btn btn-block btn-outline-dark"
                  type="button"
                >
                  <i class="fa fa-search pr-1"></i>
                  Search
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header bg-transparent">
            <div class="col-lg-12">
              Result
              <span class="float-right">
                <button
                  @click="csvExport(searchResults)"
                  class="btn btn-block btn-black"
                  type="button"
                >
                  <i class="fa fa-download pr-1"></i>
                </button>
              </span>
            </div>
            <hr>
          </div>
          <div class="card-body" v-if="isLoading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="card-body" v-else-if="searchResults.length">
            <div class="row">
              <table-component :columns="columns" :data="searchResults">
                <template slot="TED_name" slot-scope="{ row }">
                  <a :href="`/explore/${row.id}`"> {{ row.TED_name }} </a>
                </template>
                <template slot="contract_value_in_euros" slot-scope="{ row }">
                  <div align="right">{{ row.contract_value_in_euros }}</div>
                </template>
              </table-component>
            </div>
          </div>
          <div class="card-body" v-else-if="hasResult">
            <a> No result found </a>
          </div>
          <div class="card-body" v-else>
            <a> Please enter a valid name </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/constants/config";

export default {
  name: "Search",
  data() {
    return {
      BASE_URL,
      columns: [
        "TED_name",
        "TED_country",
        "EIB_Counterpart_ID",
        "EIB_Counterpart_Name",
        "MZ_Buyer_Dedup_ID",
        "TED_Buyer_Name",
        "MZ_Bidder_Dedup_ID",
        "TED_Bidder_Name",
        "contract_value_in_euros",
        "number_of_contracts",
        "cri_eib",
        "cri_eib_ted",
        "crieib_cat",
      ],
      isLoading: false,
      hasResult: false,
      searchResults: [],
      query: "",
      test: false,
    };
  },
  methods: {
    async search() {
      this.isLoading = true;
      if (this.query.length === 0) {
        this.isLoading = false;
        this.searchResults = [];
        return;
      }
      const { data } = await this.$request({url: `${BASE_URL}api/overview/search/${this.query}`});
      this.searchResults = data;
      this.hasResult = !!data.length;
      this.isLoading = false;
    },
    csvExport(arrData) {
      let csvContent = "data:text/csv;charset=utf-8,\ufeff";
      csvContent += [
        Object.keys(arrData[0]).join(";"),
        ...arrData.map((item) => Object.values(item).join(";")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "eib_search_extract.csv");
      link.click();
    },
  },
};
</script>

<style scoped></style>
